import React, { cloneElement } from 'react';
import { useLocation } from 'react-router';

import { AppHeader } from '~/components/app-header/AppHeader';
import { ChatInput, ChatInputProps } from '~/components/chat';
import { useTouchDevice } from '~/hooks/MediaQueryHook';
import { useIsEarningsInsightsEnabled } from '~/hooks/use-is-earnings-insights-enabled/useIsEarningsInsightsEnabled';
import { mobileAlfredPaths } from '~/Root';
import { AppRoute } from '~/routes';
import { MarketInsightDrawerRender } from '~/views/dashboard/whats-new-widget/components/market-insight-drawer/MarketInsightDrawerRender';
import { InsightsFullDrawerRender } from '~/views/insights/components/insights-drawer/InsightsFullDrawerRender';
import { Widgets } from '~/views/widgets/Widgets';
import { EarningsInsightDrawer } from '~/widgets/earnings-insight-drawer/EarningsInsightDrawer';
import { InsightsDrawerRender } from '~/widgets/insight-widget/components/insight-drawer/InsightsDrawerRender';

import * as S from './View.styles';

export interface AccountViewProps {
  config: AppRoute;
  showHeader: boolean;
}

export const View = ({ config, showHeader }: AccountViewProps) => {
  const location = useLocation();
  const isTouchDevice = useTouchDevice();
  const isEarningsInsightsEnabled = useIsEarningsInsightsEnabled();

  const { element } = config;

  const content = cloneElement(element, {
    renderChatInput: (props?: ChatInputProps) => <ChatInput {...props} />,
  });

  const isMobileAlfredPath =
    mobileAlfredPaths.includes(location.pathname) && isTouchDevice;

  return (
    <>
      {showHeader && !isMobileAlfredPath && <AppHeader />}
      <S.ViewRoot id={'root-view'}>
        {!isMobileAlfredPath && (
          <>
            <Widgets />
            <InsightsDrawerRender />
            <InsightsFullDrawerRender />
            <MarketInsightDrawerRender />
            {isEarningsInsightsEnabled && <EarningsInsightDrawer />}
          </>
        )}
        {content}
      </S.ViewRoot>
    </>
  );
};
